export default "__VITE_ASSET__4ab280db__"